import { StandardsProgressWidget } from "@hatch-digital-nl/abs-storybook/legacy";
import Skeleton from "react-loading-skeleton";
import { useEstablishmentId } from "../../../../common/utils/useEstablishmentId";
import { useGetEstablishmentByIdQuery } from "../../../../common/api/establishment";
import { setPrefillFilter } from "../../../qualificationListPage/QualificationListSlice";
import { useAppDispatch } from "../../../../app/hooks";
import { useNavigate } from "react-router";
import { RouteEnum } from "../../../../common/enums/RouteEnum";
import { QualificationStandardEnum } from "../../../../common/enums/QualificationStandardEnum";
import { JSX } from "react";
import { useGetQualificationsQuery } from "../../../../common/api/qualification";
import { getTotalBrancheCount } from "../../../../common/utils/getTotalBrancheCount";
import { getTotalPlusCount } from "../../../../common/utils/getTotalPlusCount";

export const DashboardStats = (): JSX.Element | null => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const {
        data: establishmentData,
        isLoading: establishmentDataIsLoading,
        isFetching: establishmentDataIsFetching,
    } = useGetEstablishmentByIdQuery({ id: useEstablishmentId() });

    const { data: qualificationData } = useGetQualificationsQuery({
        items_per_page: 9999,
    });

    if (establishmentDataIsLoading || establishmentDataIsFetching) {
        return <Skeleton height={"13.8rem"} borderRadius={"1.5rem"} />;
    }

    if (!establishmentData?.qualification_count_data) {
        return null;
    }

    return (
        <StandardsProgressWidget
            totalReadyPlusStandards={
                establishmentData?.qualification_count_data
                    ?.plus_qualifications_acquired_count ?? 0
            }
            totalPlusStandards={getTotalPlusCount(qualificationData?.data)}
            totalReadyBranchStandards={
                establishmentData?.qualification_count_data
                    ?.branche_qualifications_acquired_count ?? 0
            }
            totalBranchStandards={getTotalBrancheCount(qualificationData?.data)}
            onBranchClick={() => {
                dispatch(setPrefillFilter(QualificationStandardEnum.BRANCHE));
                navigate(RouteEnum.QUALIFICATIONS);
            }}
            onPlusClick={() => {
                dispatch(setPrefillFilter(QualificationStandardEnum.PLUS));
                navigate(RouteEnum.QUALIFICATIONS);
            }}
        />
    );
};
